export default __webpack_public_path__ + "24.05.2016_Pressemitteilung_LifeTime_Launch6a30983b12ec5b37e4b3e5f112a16456.pdf";